export enum MediaTypes {
  Document = 1,
  Image = 2,
  Video = 3
}
